// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".breadcrumb{width:100%;margin:auto;color:var(--grey-medium)}.breadcrumb:after{position:absolute;content:'';background:linear-gradient(0deg, rgba(255,255,255,0), white);opacity:1;top:0;right:20px;width:30px;height:100%}@media (max-width: 767px){.breadcrumb.sticky{height:50px;background:var(--white);display:flex;align-items:center;position:sticky;top:0;z-index:10}}.breadcrumb-list{padding:0;margin:0;-ms-overflow-style:none}@media (max-width: 969px){.breadcrumb-list{overflow-x:scroll}}.breadcrumb-list::-webkit-scrollbar{display:none}.breadcrumb-list :last-child a{pointer-events:none}@-moz-document url-prefix(){.breadcrumb-list{scrollbar-width:none}}.breadcrumb-item{font-size:var(--font-size-12);display:table-cell;list-style:none;white-space:nowrap;padding-right:var(--space-2)}.breadcrumb-item a{margin-right:var(--space-1)}.breadcrumb-item i{font-size:8px}\n", ""]);
// Exports
exports.locals = {
	"extraSmallBreakpoint": "320px",
	"smallBreakpoint": "425px",
	"mobileBreakpoint": "768px",
	"tabletBreakpoint": "970px",
	"desktopBreakpoint": "1200px",
	"largeBreakpoint": "1400px",
	"extraLargeBreakpoint": "1600px"
};
module.exports = exports;
